<template>
  <el-card class="box-card">
    <el-button @click="selectStep">select step (stepId)</el-button>
    <el-button @click="selectStepIndex">select step (index)</el-button>
    <flow
      :steps="steps"
      :editable="editable"
      :checkable="checkable"
      ref="flow"
      @selectedStep="selectedStep"
    />
    <!-- <headimg></headimg> -->

    <stage-view ref="stageView" :stageList="['11111111111111111111111111111111111111111111111111','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18']"></stage-view>

  </el-card>

</template>

<script>
import headimg from '@/components/headimg'
export default {
  components: {
    headimg:headimg
  },
  mixins: [],
  props: {},
  data() {
    return {
      editable: true,  // 是否可编辑，编辑状态适用于通用流程
      checkable: true,  // 是否可勾选，适用于生成公司/项目流程
      steps: [
        {
          stepId:11,  // 步骤id
          stepName:'aaaxxsa sdfwef', // 步骤名称
          checked:true,  // 勾选状态，当 checkable 为true时有效
          selected:false,  // 当前选中的步骤，选中时 显示橙色且有阴影    整个flow最多出现1个 selected
          isCurrent: false,  // 是否为当前步骤，显示为当前的icon       整个flow最多出现1个 isCurrent
          unexecuted: false,  // 未执行状态，当为true时，显示为灰色
          beginDate:'2019.10.11', // 执行状态下，才需要赋值。不赋值则不显示
          endDate:'2019.12.12',
          modified:true // 是否修改过
        },
        { stepId:12,stepName: '111', checked: false,selected:false,isCurrent:true,unexecuted:false },
        { stepId:13,stepName: '222', checked: true, selected:true,isCurrent:false, modified:true },
        { stepId:14,checked: false, disabled: true, checked: false, selected:false,unexecuted:true },
        { stepId:15,checked: false, disabled: true, checked: false,selected:false,unexecuted:true,isCurrent:false }
      ]
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    /** 选中反馈 */
    selectedStep(step) {
      console.log(step)
    },
    /** 通过stepid 选中 */
    selectStep(){
      this.$refs.flow.selectStep(15)
    },
    selectStepIndex(){
      this.$refs.flow.selectStepIndex(0);

      
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
